export default "__VITE_ASSET__DEgcfUnz__"